export const CONFIRM_DELETE =
  "Bạn có chắc chắn muốn xóa file đính kèm này không?";

export const HELP_TEXT =
  "Chỉ nhận file jpg, jpeg, png, pdf, doc, docx, xls, xlsx. Tải tối đa 15 file. Tổng dung lượng tối đa 20MB.";

export const ERROR_TEXT_TYPE =
  "Định dạng file không đúng. Chỉ nhận file jpg, jpeg, png, pdf, doc, docx, xls, xlsx.";

export const ERROR_TEXT_SIZE = "Dung lượng tối đa: 20MB";

export const MAX_FILES = 15;

export const ACCEPT_FILES = ".png,.jpg,.jpeg,.pdf,.doc,.docx,.xls,.xlsx";

export const MAX_SIZE = "20MB";

export const FILE_FIELDS = [
  "Ten",
  "Kieu",
  "KieuDinhKem",
  "Ext",
  "KichThuoc",
  "NoiDungKichThuoc",
  "Id",
  "KienNghiId",
  "DuongDan",
  "ThoiGianCapNhat",
  "ThoiGianTaoMoi",
  "ThuTu"
];

export const LOI_UPLOAD_QUA_KICH_THUOC = "Tổng dung lượng file tối đa: 20MB";
